import css from './textStatisticCard.module.css'
import { CSSProperties, PropsWithChildren } from 'react'
import Skeleton from '@/shared/Loaders/Skeleton'
import AnalyticsProgressCircle, { IAnalyticsCircleProps } from '@/shared/Analytics/AnalyticsProgressCircle'
import QuestionIconWithTooltip from '@/shared/Common/QuestionIconWithTooltip'

interface IProps {
  title: string
  circleConfig: IAnalyticsCircleProps
  labelTooltipText?: string
  style?: CSSProperties
}

interface IPropsWithSkeleton extends IProps {
  loading: boolean
  width: string
  height: string
}

const AnalyticsProgressCard = (props: PropsWithChildren<IProps | IPropsWithSkeleton>) => {
  return (
    <Skeleton
      height={'height' in props ? props.height : ''}
      width={'width' in props ? props.width : undefined}
      loading={'loading' in props ? props.loading : false}
    >
      <div className={css.wrapper} style={props.style}>
        <div className="flex-lines gap12 center width100">
          <div className="inline-flex-gap gap8 center" style={{ marginRight: 'auto' }}>
            <p className="text-nm text-description">{props.title}</p>
            {props.labelTooltipText && <QuestionIconWithTooltip text={props.labelTooltipText} position="bottom" />}
          </div>
          <AnalyticsProgressCircle
            type={props.circleConfig.type}
            value={props.circleConfig.value}
            size={props.circleConfig.size}
          />
        </div>
      </div>
    </Skeleton>
  )
}

export default AnalyticsProgressCard
